AppTabs.createTab( {

name: 'invoice',
icon: 'file-alt',
text: 'Invoice',
create: function(init) {
	'use strict'

	const fields = [
		{
			label: 		'City',
			columnName: 'City',
		},
		{
			label: 		'Test',
			columnName: 'TestDisplayName',
		},
		{
			label: 		'Count',
			columnName: 'Count',
		},
	];

	const tab = this;
	init.setDataTableArgs( {

		tableId: 		'#datatable-invoice',

		// tables used by DataTables actions
		// complex queries hardcoded in ajax actions

		primaryKey: 	'TestID',

		hasColumnFilters: 	false,
		canSearch: 			false,
		canSort:			true,
		drawWhen:           false,

		// Ajax action endpoints
		// these also serve as flags as to whether to show the editor buttons or add the autofill eventListener
		actionData:			'datatable_invoice',
		actionPrint:        true,
		exportActions:      true,

		// Adds additional data fields to ajax requests when drawing the table
		ajaxDataCallback : function( data, settings ) {
			const vm           = tab.controller;
			data.clientID      = vm && vm.client ? vm.client.id : -1;
			data.projectName   = vm.projectName;
			data.projectNumber = vm && vm.projectNumber !== undefined ? vm.projectNumber : -1;
			data.loginDateFrom = vm.loginDateFrom;
			data.loginDateTo   = vm.loginDateTo;
			console.log( { vm, tab, data } );
			return data;
		},

		fields: fields,

	} );

	init.setController( new TabControllerVue({
		el: '#invoice-datatable-filters',
		computed: {
			clients: function() {
				return LocalStorageManager.get( 'clientList' );
			},
		},
		methods: {
			resetData() {
				this.client         = null;
				this.projectName    = null;
				this.projectNames   = [];
				this.projectNumber  = null;
				this.projectNumbers = [];
				this.loginDateFrom  = null;
				this.loginDateTo    = null;

				this.fetchingProjectNames   = false;
				this.fetchingProjectNumbers = false;
			},
			onShowTab: function() {
				this.ajaxLoadProjectNames();
				this.ajaxLoadProjectNumbers();
			},
			ajaxLoadProjectNames(prefix = '') {
				const _this = this;
				_this.fetchingProjectNames = false;

				window.ajaxCall({
					data : {
						action: 'get_project_names_by_client',
						clientId: this.client ? this.client.id : null,
						prefix,
					},
					onSuccess( response ) {
						if ((response.data && response.data.length) || !prefix) {
							_this.projectNames = response.data;
							_this.fetchingProjectNames = false;
						} else
							_this.ajaxLoadProjectNames();
					},
					onError( response ) {
						_this.fetchingProjectNames = false;
						alert( _this.client
							? 'Could not load Project Names for ' + _this.client.text
							: 'Could not load Project Names' );
					},
				});
			},
			ajaxLoadProjectNumbers(prefix = '') {
				if ( ! this.client ) {
					this.projectNumbers = ['loading...'];
				}
				const _this = this;
				_this.fetchingProjectNumbers = true;

				window.ajaxCall({
					data : {
						action: 'get_project_numbers_by_client',
						clientId: this.client ? this.client.id : null,
						prefix,
					},
					onSuccess( response ) {
						if ((response.data && response.data.length) || !prefix) {
							_this.projectNumbers = response.data;
							_this.fetchingProjectNumbers = false;
						} else
							_this.ajaxLoadProjectNumbers();
					},
					onError( response ) {
						_this.fetchingProjectNumbers = false;
						alert( _this.client
							? 'Could not load Project Numbers for ' + _this.client.text
							: 'Could not load Project Numbers' );
					},
				});
			},
			search() { tab.drawTable(); },
		},
		watch: {
			client: function( newValue, oldValue ) {
				console.log('watch client', newValue, oldValue);
				this.projectName = null;
				this.projectNames = [];
				this.projectNumber = null;
				this.projectNumbers = [];
				this.ajaxLoadProjectNames();
				this.ajaxLoadProjectNumbers();
			}
		}
	}) );

}

} );
